export async function getRecaptchaToken(refCaptcha) {
    if (['develop', 'homolog'].includes(process.env.REACT_APP_ENVIRONMENT)) {
        return null
    }

    refCaptcha.current.reset()
    return await refCaptcha.current.executeAsync()
}
